import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicHeader from './PublicHeader';

type PublicLayoutProps = {
  hideHeader?: boolean;
};

const PublicLayout: React.FC<PublicLayoutProps> = ({ hideHeader = false }) => {
  return (
    <div className="flex h-[100dvh] flex-col bg-white">
      {!hideHeader && <PublicHeader />}

      <main className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default PublicLayout;
